export default __webpack_public_path__ + "static/about-1-ba6a514bca5a6439e10356ad20a543e9.png";